import _classCallCheck from "/home/runner/work/deckdeckgo/deckdeckgo/site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/deckdeckgo/deckdeckgo/site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _asyncToGenerator from "/home/runner/work/deckdeckgo/deckdeckgo/site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/deckdeckgo/deckdeckgo/site/node_modules/@babel/runtime/regenerator/index.js";
import { h, r as registerInstance, c as createEvent, H as Host, g as getElement } from './index-4ed2a3e3.js';
import { a as a$1, s as s$1, x, d, c as _containerSize, l, m } from './size.utils-4aae53d5.js';
function r(t) {
  return new Promise(function (o) {
    if (!t) {
      o();
      return;
    }
    t.forEach(function (e) {
      e.hasAttribute("data-src") && (e.setAttribute("src", "".concat(e.getAttribute("data-src"))), e.removeAttribute("data-src"), e.classList.contains("deckgo-reveal") || e.style.setProperty("visibility", "inherit")), e.style.setProperty("pointer-events", "none");
    }), o();
  });
}
var s = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t) {
    var o;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            o = t.map(function (e) {
              return e.lazyLoad();
            });
            _context.next = 3;
            return Promise.all(o);
          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function s(_x) {
    return _ref.apply(this, arguments);
  };
}();
function a(e) {
  return new Promise( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(n) {
      var t;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (e) {
                _context2.next = 3;
                break;
              }
              n(null);
              return _context2.abrupt("return");
            case 3:
              _context2.next = 5;
              return c(e.attributes);
            case 5:
              t = _context2.sent;
              n({
                template: e.tagName ? e.tagName.toLowerCase() : void 0,
                content: e.innerHTML,
                attributes: t
              });
            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }());
}
function c(e) {
  return new Promise( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(n) {
      var t;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(!e || e.length <= 0)) {
                _context3.next = 3;
                break;
              }
              n(null);
              return _context3.abrupt("return");
            case 3:
              t = [];
              Array.prototype.slice.call(e).forEach(function (i) {
                if (["id", "hydrated", "class", "contenteditable"].indexOf(i.name.toLowerCase()) === -1) {
                  var o = {
                    name: i.name
                  };
                  i.value !== void 0 && (o.value = "".concat(i.value)), t.push(o);
                }
              }), n(t && t.length > 0 ? t : null);
            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }());
}
var DeckdeckgoDeckBackgroundUtils = /*#__PURE__*/function () {
  function DeckdeckgoDeckBackgroundUtils() {
    _classCallCheck(this, DeckdeckgoDeckBackgroundUtils);
  }
  _createClass(DeckdeckgoDeckBackgroundUtils, null, [{
    key: "lazyBackgroundImages",
    value:
    // Lazy load images from slot=background
    function lazyBackgroundImages(el) {
      var _this = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(resolve) {
          var promises;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  promises = [];
                  promises.push(_this.lazyBackgroundImgTags(el));
                  promises.push(_this.lazyBackgroundImgComponents(el));
                  _context4.next = 5;
                  return Promise.all(promises);
                case 5:
                  resolve();
                case 6:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));
        return function (_x4) {
          return _ref4.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "lazyBackgroundImgTags",
    value: function lazyBackgroundImgTags(el) {
      return new Promise( /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(resolve) {
          var allSlottedImages, allShadowImages, images;
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  allSlottedImages = el.querySelectorAll("img[slot='background']");
                  allShadowImages = el.querySelectorAll("[slot='background'] img");
                  images = Array.from(allSlottedImages).concat(Array.from(allShadowImages));
                  _context5.next = 5;
                  return r(images);
                case 5:
                  resolve();
                case 6:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));
        return function (_x5) {
          return _ref5.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "lazyBackgroundImgComponents",
    value: function lazyBackgroundImgComponents(el) {
      return new Promise( /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(resolve) {
          var allShadowImagesComponents, images;
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  allShadowImagesComponents = el.querySelectorAll(":scope > [slot='background'] deckgo-lazy-img");
                  images = Array.from(allShadowImagesComponents);
                  _context6.next = 4;
                  return s(images);
                case 4:
                  resolve();
                case 5:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));
        return function (_x6) {
          return _ref6.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "loadSlots",
    value: function loadSlots(el, slides, slotName) {
      var _this2 = this;
      var clone = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      return new Promise( /*#__PURE__*/function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(resolve) {
          var background;
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  background = el.querySelector(":scope > [slot='".concat(slotName, "']"));
                  if (background) {
                    _context7.next = 4;
                    break;
                  }
                  resolve();
                  return _context7.abrupt("return");
                case 4:
                  _context7.next = 6;
                  return _this2.lazyBackgroundImages(el);
                case 6:
                  if (!clone) {
                    _context7.next = 9;
                    break;
                  }
                  _context7.next = 9;
                  return _this2.cloneSlots(el, slides, slotName);
                case 9:
                  _context7.next = 11;
                  return _this2.showHideBackgroundSlot(el, clone);
                case 11:
                  resolve();
                case 12:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }));
        return function (_x7) {
          return _ref7.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "loadSlot",
    value: function () {
      var _loadSlot = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(el, slide, slotName) {
        var clone,
          slot,
          _args8 = arguments;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                clone = _args8.length > 3 && _args8[3] !== undefined ? _args8[3] : true;
                slot = el.querySelector(":scope > [slot='".concat(slotName, "']"));
                if (slot) {
                  _context8.next = 4;
                  break;
                }
                return _context8.abrupt("return");
              case 4:
                _context8.next = 6;
                return this.lazyBackgroundImages(el);
              case 6:
                if (!clone) {
                  _context8.next = 9;
                  break;
                }
                _context8.next = 9;
                return this.cloneSlot(el, slide, slotName);
              case 9:
                _context8.next = 11;
                return this.showHideBackgroundSlot(el, clone);
              case 11:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
      function loadSlot(_x8, _x9, _x10) {
        return _loadSlot.apply(this, arguments);
      }
      return loadSlot;
    }()
  }, {
    key: "showHideBackgroundSlot",
    value: function showHideBackgroundSlot(el, cloneBackground) {
      return new Promise( /*#__PURE__*/function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(resolve) {
          var slider;
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  slider = el.shadowRoot.host;
                  if (slider) {
                    _context9.next = 4;
                    break;
                  }
                  resolve();
                  return _context9.abrupt("return");
                case 4:
                  if (!cloneBackground) {
                    slider.style.removeProperty('--background-display');
                  }
                  resolve();
                case 6:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9);
        }));
        return function (_x11) {
          return _ref8.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "cloneSlots",
    value: function cloneSlots(el, slides, slotName) {
      var _this3 = this;
      return new Promise(function (resolve) {
        if (!slides || slides.length <= 0) {
          resolve();
          return;
        }
        var slotElement = el.querySelector(":scope > [slot='" + slotName + "']");
        if (slotElement) {
          slides.forEach(function (slide) {
            _this3.appendSlot(slotElement, slide, slotName);
          });
        }
        resolve();
      });
    }
  }, {
    key: "cloneSlot",
    value: function () {
      var _cloneSlot = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(el, slide, slotName) {
        var slotElement;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (slide) {
                  _context10.next = 2;
                  break;
                }
                return _context10.abrupt("return");
              case 2:
                slotElement = el.querySelector(":scope > [slot='" + slotName + "']");
                this.appendSlot(slotElement, slide, slotName);
              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
      function cloneSlot(_x12, _x13, _x14) {
        return _cloneSlot.apply(this, arguments);
      }
      return cloneSlot;
    }()
  }, {
    key: "appendSlot",
    value: function appendSlot(slotElement, slide, slotName) {
      if (!slotElement) {
        return;
      }
      var custom = slide.hasAttribute('custom-' + slotName);
      if (!custom) {
        var currentSlotElement = slide.querySelector(":scope > [slot='" + slotName + "']");
        if (currentSlotElement) {
          slide.removeChild(currentSlotElement);
        }
        slide.appendChild(slotElement.cloneNode(true));
      }
    }
  }, {
    key: "removeSlots",
    value: function removeSlots(slides, slotName) {
      return new Promise(function (resolve) {
        if (!slides || slides.length <= 0) {
          resolve();
          return;
        }
        slides.forEach(function (slide) {
          var custom = slide.hasAttribute('custom-' + slotName);
          if (!custom) {
            var currentSlotElement = slide.querySelector(":scope > [slot='" + slotName + "']");
            if (currentSlotElement) {
              slide.removeChild(currentSlotElement);
            }
          }
        });
        resolve();
      });
    }
  }]);
  return DeckdeckgoDeckBackgroundUtils;
}();
var HideSlides = function HideSlides() {
  // Note: a start (hidden) opacity of 0 would has for effect to produce some "white flash" on transition.
  // Setting a value like 0.4 reduce the flash effect and makes the transition smoother for my eyes.
  // Note: if --slide-animation is not defined we have to set a value otherwise the property isn't a valid property.
  // Therefore we add a transition on visibility, it has no impact.
  return h("style", null, "\n      ::slotted(.deckgo-slide-container) {\n        opacity: var(--animation-fade-hidden-opacity, 0.4);\n        visibility: hidden;\n        transition: opacity var(--animation-fade-duration, 500ms) cubic-bezier(0.23, 1, 0.320, 1), var(--slide-animation, visibility 500ms);\n      };\n    ");
};
var RevealSlide = function RevealSlide(_ref9) {
  var index = _ref9.index;
  return h("style", null, "\n      ::slotted(.deckgo-slide-container:nth-child(".concat(index + 1, ")) {\n        visibility: initial;\n        opacity: 1;\n      };\n    "));
};
var AnimationSlide = function AnimationSlide() {
  return h("style", null, "\n      ::slotted(.deckgo-slide-container) {\n        transition: var(--slide-animation);\n      }\n    ");
};
var deckCss = ":host{display:block;position:relative;width:100%;height:100%;contain:size style}main{position:absolute;left:0;right:0;top:0;bottom:0;box-sizing:border-box;-webkit-overflow-scrolling:touch;will-change:scroll-position;touch-action:auto}:host(.vertical) main,:host(.horizontal) main{overflow:hidden}:host(.papyrus) main{overflow-x:hidden}:host(.vertical) main,:host(.papyrus) main{touch-action:pan-y;overscroll-behavior-y:contain}:host(.horizontal) main{touch-action:pan-x;overscroll-behavior-x:contain}div.deckgo-deck{display:flex;position:absolute;top:0;bottom:0;z-index:var(--zIndex);--transformX:0px;--transformY:0px;--transformXDuration:0ms;transform:translate3d(var(--transformX), var(--transformY), 0px);transition-duration:var(--transformXDuration, 0ms);--slide-width:100vw;--slide-height:100%;font-size:var(--slide-font-size, var(--slide-auto-font-size, 1em))}div.deckgo-deck ::-webkit-scrollbar{display:none}:host(.vertical) div.deckgo-deck,:host(.papyrus) div.deckgo-deck{flex-direction:column}:host(.papyrus) div.deckgo-deck{--slide-user-select:auto}::slotted([slot=background]){display:var(--background-display, none);pointer-events:none}::slotted([slot=actions]){display:none}@media print{:host(.vertical) main,:host(.horizontal) main{overflow:visible}:host(.papyrus) main{overflow-x:visible}:host>*{page-break-after:always}}";
var DeckGoDeck = /*#__PURE__*/function () {
  function DeckGoDeck(hostRef) {
    var _this4 = this;
    _classCallCheck(this, DeckGoDeck);
    registerInstance(this, hostRef);
    this.slidesDidLoad = createEvent(this, "slidesDidLoad", 7);
    this.slideNextDidAnimate = createEvent(this, "slideNextDidAnimate", 7);
    this.slidePrevDidAnimate = createEvent(this, "slidePrevDidAnimate", 7);
    this.slideNextDidChange = createEvent(this, "slideNextDidChange", 7);
    this.slidePrevDidChange = createEvent(this, "slidePrevDidChange", 7);
    this.slideToChange = createEvent(this, "slideToChange", 7);
    this.slideDrag = createEvent(this, "slideDrag", 7);
    this.slideWillChange = createEvent(this, "slideWillChange", 7);
    this.deckDidLoad = createEvent(this, "deckDidLoad", 7);
    this.mouseInactivity = createEvent(this, "mouseInactivity", 7);
    this.keyboard = true;
    this.embedded = false;
    this.cloneBackground = true;
    this.rtl = false;
    this.startX = null;
    this.startY = null;
    this.deckMove = 0;
    this.autoSwipeRatio = 10;
    this.block = false;
    this.activeIndex = 0;
    this.length = 0;
    this.fullscreen = false;
    this.cursorHidden = false;
    this.idleMouseTimeout = 2000;
    this.reveal = true;
    this.revealOnMobile = false;
    this.animation = 'slide';
    this.direction = 'horizontal';
    this.directionMobile = 'papyrus';
    this.autoSlide = 'false';
    this.autoSlideInterval = 5000;
    // We do not consider iPad and Tablet as "mobile" devices. With mobile we mean smaller devices, phones.
    this.mobile = a$1() && !(s$1() || x());
    this.debounceWindowResize = d( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
      var toggleFullscreen;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return _this4.initSlideSize();
            case 2:
              if (!(_this4.dir !== 'papyrus')) {
                _context11.next = 5;
                break;
              }
              _context11.next = 5;
              return _this4.slideTo(_this4.activeIndex);
            case 5:
              toggleFullscreen = m();
              _context11.next = 8;
              return _this4.hideOrClearMouseCursorTimer(toggleFullscreen);
            case 8:
              _context11.next = 10;
              return _this4.showHideActionsSlot(toggleFullscreen);
            case 10:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    })), 100);
    this.onIntersection = /*#__PURE__*/function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(entries) {
        var intersectingElements, promises;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (!(!entries || entries.length <= 0)) {
                  _context13.next = 2;
                  break;
                }
                return _context13.abrupt("return");
              case 2:
                intersectingElements = entries.filter(function (entry) {
                  return entry.isIntersecting;
                }).map(function (entry) {
                  return entry.target;
                });
                if (!(!intersectingElements || intersectingElements.length <= 0)) {
                  _context13.next = 5;
                  break;
                }
                return _context13.abrupt("return");
              case 5:
                promises = intersectingElements.map(function (element) {
                  return new Promise( /*#__PURE__*/function () {
                    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(resolve) {
                      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                        while (1) {
                          switch (_context12.prev = _context12.next) {
                            case 0:
                              _this4.observer.unobserve(element);
                              _context12.next = 3;
                              return element.lazyLoadContent();
                            case 3:
                              resolve();
                            case 4:
                            case "end":
                              return _context12.stop();
                          }
                        }
                      }, _callee12);
                    }));
                    return function (_x16) {
                      return _ref12.apply(this, arguments);
                    };
                  }());
                });
                _context13.next = 8;
                return Promise.all(promises);
              case 8:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));
      return function (_x15) {
        return _ref11.apply(this, arguments);
      };
    }();
    this.keyboardAssist = /*#__PURE__*/function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14($event) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (!$event.defaultPrevented) {
                  _context14.next = 2;
                  break;
                }
                return _context14.abrupt("return");
              case 2:
                if (!(['ArrowLeft', 'k', 'PageUp'].indexOf($event.key) !== -1)) {
                  _context14.next = 7;
                  break;
                }
                _context14.next = 5;
                return _this4.slideNextPrev(false, true, true);
              case 5:
                _context14.next = 10;
                break;
              case 7:
                if (!(['ArrowRight', 'j', 'PageDown'].indexOf($event.key) !== -1)) {
                  _context14.next = 10;
                  break;
                }
                _context14.next = 10;
                return _this4.slideNextPrev(true, true, true);
              case 10:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));
      return function (_x17) {
        return _ref13.apply(this, arguments);
      };
    }();
  }
  _createClass(DeckGoDeck, [{
    key: "componentWillLoad",
    value: function () {
      var _componentWillLoad = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.initRtl();
              case 2:
                _context15.next = 4;
                return this.initDirection();
              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));
      function componentWillLoad() {
        return _componentWillLoad.apply(this, arguments);
      }
      return componentWillLoad;
    }()
  }, {
    key: "componentDidLoad",
    value: function () {
      var _componentDidLoad = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.initSlideSize();
              case 2:
                _context16.next = 4;
                return this.initAutoSlide();
              case 4:
                this.initWindowResize();
                this.initKeyboardAssist();
              case 6:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));
      function componentDidLoad() {
        return _componentDidLoad.apply(this, arguments);
      }
      return componentDidLoad;
    }()
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
      if (this.idleSlideLoopTimer > 0) {
        clearTimeout(this.idleSlideLoopTimer);
      }
      if (this.slideLoopInterval > 0) {
        clearInterval(this.slideLoopInterval);
      }
      if (this.idleMouseTimer > 0) {
        clearTimeout(this.idleMouseTimer);
      }
      window === null || window === void 0 ? void 0 : window.removeEventListener('resize', this.debounceWindowResize);
    }
  }, {
    key: "initRtl",
    value: function initRtl() {
      var _this5 = this;
      return new Promise(function (resolve) {
        if (document && document.documentElement) {
          var htmlDir = document.documentElement.getAttribute('dir');
          _this5.rtl = htmlDir && htmlDir === 'rtl';
        }
        resolve();
      });
    }
  }, {
    key: "initWindowResize",
    value: function initWindowResize() {
      window === null || window === void 0 ? void 0 : window.addEventListener('resize', this.debounceWindowResize);
    }
  }, {
    key: "initSlideSize",
    value: function () {
      var _initSlideSize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (this.embedded) {
                  _context17.next = 4;
                  break;
                }
                _context17.next = 3;
                return this.initSlideSizeStandard();
              case 3:
                return _context17.abrupt("return");
              case 4:
                _context17.next = 6;
                return this.initSlideSizeEmbedded();
              case 6:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));
      function initSlideSize() {
        return _initSlideSize.apply(this, arguments);
      }
      return initSlideSize;
    }()
  }, {
    key: "initSlideSizeStandard",
    value: function () {
      var _initSlideSizeStandard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        var _a, _b, _c, _d, _e, sliderSize;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                sliderSize = this.containerSize();
                (_a = this.containerRef) === null || _a === void 0 ? void 0 : _a.style.setProperty('--slide-width', "".concat(sliderSize.width, "px"));
                if (this.dir === 'papyrus') {
                  (_b = this.containerRef) === null || _b === void 0 ? void 0 : _b.style.setProperty('--slide-min-height', "".concat(sliderSize.height, "px"));
                  (_c = this.containerRef) === null || _c === void 0 ? void 0 : _c.style.removeProperty('--slide-height');
                } else {
                  (_d = this.containerRef) === null || _d === void 0 ? void 0 : _d.style.removeProperty('--slide-min-height');
                  (_e = this.containerRef) === null || _e === void 0 ? void 0 : _e.style.setProperty('--slide-height', "".concat(sliderSize.height, "px"));
                }
                _context18.next = 5;
                return this.initFontSize({
                  height: sliderSize.height,
                  width: sliderSize.width
                });
              case 5:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));
      function initSlideSizeStandard() {
        return _initSlideSizeStandard.apply(this, arguments);
      }
      return initSlideSizeStandard;
    }()
  }, {
    key: "containerSize",
    value: function containerSize() {
      return _containerSize({
        embedded: this.embedded,
        container: this.containerRef
      });
    }
  }, {
    key: "initSlideSizeEmbedded",
    value: function () {
      var _initSlideSizeEmbedded = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        var offsetParent;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                if (!(!this.containerRef || !this.containerRef.offsetParent)) {
                  _context19.next = 2;
                  break;
                }
                return _context19.abrupt("return");
              case 2:
                offsetParent = this.containerRef.offsetParent;
                if (offsetParent.clientWidth > 0) {
                  this.containerRef.style.setProperty('--slide-width', '' + offsetParent.clientWidth + 'px');
                }
                if (offsetParent.clientHeight > 0 && this.dir === 'papyrus') {
                  this.containerRef.style.setProperty('--slide-min-height', '' + offsetParent.clientHeight + 'px');
                  this.containerRef.style.removeProperty('--slide-height');
                }
                if (offsetParent.clientHeight > 0 && this.dir !== 'papyrus') {
                  this.containerRef.style.removeProperty('--slide-min-height');
                  this.containerRef.style.setProperty('--slide-height', '' + offsetParent.clientHeight + 'px');
                }
                _context19.next = 8;
                return this.initFontSize({
                  height: offsetParent.clientHeight,
                  width: offsetParent.clientWidth
                });
              case 8:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));
      function initSlideSizeEmbedded() {
        return _initSlideSizeEmbedded.apply(this, arguments);
      }
      return initSlideSizeEmbedded;
    }()
  }, {
    key: "initFontSize",
    value: function () {
      var _initFontSize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(_ref14) {
        var height, width, _a, _b, fontSize, ratioFontSize;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                height = _ref14.height, width = _ref14.width;
                // 576px height = font-size 16px or 1em (relative to the font-size of its direct or nearest parent)
                fontSize = height / 576;
                ratioFontSize = width / 16 * 9 / 576;
                (_a = this.containerRef) === null || _a === void 0 ? void 0 : _a.style.setProperty('--slide-auto-font-size', "".concat(fontSize, "em"));
                (_b = this.containerRef) === null || _b === void 0 ? void 0 : _b.style.setProperty('--slide-auto-ratio-font-size', "".concat(ratioFontSize, "em"));
              case 5:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));
      function initFontSize(_x18) {
        return _initFontSize.apply(this, arguments);
      }
      return initFontSize;
    }()
  }, {
    key: "initKeyboardAssist",
    value: function initKeyboardAssist() {
      if (document && this.keyboard) {
        document.addEventListener('keydown', this.keyboardAssist, {
          passive: true
        });
      }
    }
  }, {
    key: "initLazyLoadContent",
    value: function () {
      var _initLazyLoadContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                if (!(window && 'IntersectionObserver' in window)) {
                  _context21.next = 5;
                  break;
                }
                _context21.next = 3;
                return this.deferIntersectionObserverLoad();
              case 3:
                _context21.next = 7;
                break;
              case 5:
                _context21.next = 7;
                return this.lazyLoadAllContent();
              case 7:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));
      function initLazyLoadContent() {
        return _initLazyLoadContent.apply(this, arguments);
      }
      return initLazyLoadContent;
    }()
  }, {
    key: "deferIntersectionObserverLoad",
    value: function () {
      var _deferIntersectionObserverLoad = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
        var _this6 = this;
        var slides;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                slides = this.el.querySelectorAll('.deckgo-slide-container');
                if (!(!slides || slides.length <= 0)) {
                  _context22.next = 3;
                  break;
                }
                return _context22.abrupt("return");
              case 3:
                if (this.observer) {
                  this.observer.disconnect();
                }
                this.observer = new IntersectionObserver(this.onIntersection, {
                  rootMargin: '300px',
                  threshold: 0
                });
                slides.forEach(function (slide) {
                  _this6.observer.observe(slide);
                });
              case 6:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));
      function deferIntersectionObserverLoad() {
        return _deferIntersectionObserverLoad.apply(this, arguments);
      }
      return deferIntersectionObserverLoad;
    }()
  }, {
    key: "toggleKeyboardAssist",
    value: function () {
      var _toggleKeyboardAssist = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(state) {
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                if (this.keyboard) {
                  _context23.next = 2;
                  break;
                }
                return _context23.abrupt("return");
              case 2:
                if (state) {
                  document.addEventListener('keydown', this.keyboardAssist, {
                    passive: true
                  });
                } else {
                  // @ts-ignore
                  document.removeEventListener('keydown', this.keyboardAssist, {
                    passive: true
                  });
                }
              case 3:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));
      function toggleKeyboardAssist(_x19) {
        return _toggleKeyboardAssist.apply(this, arguments);
      }
      return toggleKeyboardAssist;
    }()
  }, {
    key: "onDirectionMobileChange",
    value: function () {
      var _onDirectionMobileChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.next = 2;
                return this.initDirection();
              case 2:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));
      function onDirectionMobileChange() {
        return _onDirectionMobileChange.apply(this, arguments);
      }
      return onDirectionMobileChange;
    }()
  }, {
    key: "onDirectionChange",
    value: function () {
      var _onDirectionChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _context25.next = 2;
                return this.initDirection();
              case 2:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));
      function onDirectionChange() {
        return _onDirectionChange.apply(this, arguments);
      }
      return onDirectionChange;
    }()
  }, {
    key: "initDirection",
    value: function () {
      var _initDirection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                this.dir = this.mobile ? this.directionMobile : this.direction;
              case 1:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));
      function initDirection() {
        return _initDirection.apply(this, arguments);
      }
      return initDirection;
    }() /* BEGIN: Handle swipe */
  }, {
    key: "mousedown",
    value: function mousedown($event) {
      this.start($event);
    }
  }, {
    key: "touchstart",
    value: function touchstart($event) {
      this.start($event);
    }
  }, {
    key: "mouseup",
    value: function () {
      var _mouseup = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27($event) {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.next = 2;
                return this.stop($event);
              case 2:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));
      function mouseup(_x20) {
        return _mouseup.apply(this, arguments);
      }
      return mouseup;
    }()
  }, {
    key: "touchend",
    value: function () {
      var _touchend = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28($event) {
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.next = 2;
                return this.stop($event);
              case 2:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));
      function touchend(_x21) {
        return _touchend.apply(this, arguments);
      }
      return touchend;
    }()
  }, {
    key: "mousemove",
    value: function () {
      var _mousemove = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29($event) {
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.next = 2;
                return this.move($event);
              case 2:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));
      function mousemove(_x22) {
        return _mousemove.apply(this, arguments);
      }
      return mousemove;
    }()
  }, {
    key: "touchmove",
    value: function () {
      var _touchmove = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30($event) {
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.next = 2;
                return this.move($event);
              case 2:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));
      function touchmove(_x23) {
        return _touchmove.apply(this, arguments);
      }
      return touchmove;
    }()
  }, {
    key: "dblclick",
    value: function () {
      var _dblclick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31() {
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                this.resetStart();
              case 1:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));
      function dblclick() {
        return _dblclick.apply(this, arguments);
      }
      return dblclick;
    }()
  }, {
    key: "contextMenu",
    value: function () {
      var _contextMenu = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32() {
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                this.resetStart();
              case 1:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));
      function contextMenu() {
        return _contextMenu.apply(this, arguments);
      }
      return contextMenu;
    }()
  }, {
    key: "scrolling",
    value: function scrolling($event) {
      this.block = $event ? $event.detail : false;
    }
  }, {
    key: "keypress",
    value: function () {
      var _keypress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33() {
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                _context33.next = 2;
                return this.clearMouseCursorTimer(true);
              case 2:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));
      function keypress() {
        return _keypress.apply(this, arguments);
      }
      return keypress;
    }()
  }, {
    key: "start",
    value: function start($event) {
      var css = window.getComputedStyle($event.target);
      this.block = (css === null || css === void 0 ? void 0 : css.userSelect) === 'text' || (css === null || css === void 0 ? void 0 : css.getPropertyValue('-webkit-user-select')) === 'text' || (css === null || css === void 0 ? void 0 : css.getPropertyValue('-moz-user-select')) === 'text' || (css === null || css === void 0 ? void 0 : css.getPropertyValue('-ms-user-select')) === 'text';
      this.startX = l($event).clientX;
      this.startY = l($event).clientY;
    }
  }, {
    key: "move",
    value: function () {
      var _move = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34($event) {
        var _a, delta;
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                _context34.next = 2;
                return this.clearMouseCursorTimer(true);
              case 2:
                if (!this.block) {
                  _context34.next = 4;
                  break;
                }
                return _context34.abrupt("return");
              case 4:
                if (!(this.animation !== 'slide')) {
                  _context34.next = 6;
                  break;
                }
                return _context34.abrupt("return");
              case 6:
                _context34.next = 8;
                return this.getDelta($event);
              case 8:
                delta = _context34.sent;
                if (delta) {
                  _context34.next = 11;
                  break;
                }
                return _context34.abrupt("return");
              case 11:
                this.moveX(delta);
                this.moveY(delta);
                (_a = this.containerRef) === null || _a === void 0 ? void 0 : _a.style.setProperty('--transformXDuration', '0ms');
              case 14:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));
      function move(_x24) {
        return _move.apply(this, arguments);
      }
      return move;
    }()
  }, {
    key: "moveX",
    value: function moveX(delta) {
      var _a;
      if (this.dir !== 'horizontal') {
        return;
      }
      var transformX = delta.swipeNext ? this.deckMove - delta.deltaX : this.deckMove + delta.deltaX;
      (_a = this.containerRef) === null || _a === void 0 ? void 0 : _a.style.setProperty('--transformX', transformX + 'px');
      this.slideDrag.emit(transformX);
    }
  }, {
    key: "moveY",
    value: function moveY(delta) {
      var _a;
      if (this.dir !== 'vertical') {
        return;
      }
      var transformY = delta.swipeNext ? this.deckMove - delta.deltaY : this.deckMove + delta.deltaY;
      (_a = this.containerRef) === null || _a === void 0 ? void 0 : _a.style.setProperty('--transformY', transformY + 'px');
      this.slideDrag.emit(transformY);
    }
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35($event) {
        var delta;
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                if (!this.block) {
                  _context35.next = 2;
                  break;
                }
                return _context35.abrupt("return");
              case 2:
                _context35.next = 4;
                return this.getDelta($event);
              case 4:
                delta = _context35.sent;
                _context35.next = 7;
                return this.swipeSlide(delta);
              case 7:
                this.resetStart();
              case 8:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));
      function stop(_x25) {
        return _stop.apply(this, arguments);
      }
      return stop;
    }()
  }, {
    key: "swipeSlide",
    value: function swipeSlide(delta) {
      var _this7 = this;
      var emitEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return new Promise( /*#__PURE__*/function () {
        var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(resolve) {
          var couldSwipeNext, couldSwipePrevious, sliderSize, autoSwipeHorizontal, autoSwipeVertical;
          return _regeneratorRuntime.wrap(function _callee36$(_context36) {
            while (1) {
              switch (_context36.prev = _context36.next) {
                case 0:
                  if (!(!delta || !window)) {
                    _context36.next = 3;
                    break;
                  }
                  resolve();
                  return _context36.abrupt("return");
                case 3:
                  couldSwipeNext = delta.swipeNext && _this7.activeIndex < _this7.length - 1;
                  couldSwipePrevious = !delta.swipeNext && _this7.activeIndex > 0;
                  if (_this7.rtl) {
                    couldSwipeNext = delta.swipeNext && _this7.activeIndex > 0;
                    couldSwipePrevious = !delta.swipeNext && _this7.activeIndex < _this7.length - 1;
                  }
                  if (couldSwipeNext || couldSwipePrevious) {
                    sliderSize = _this7.containerSize();
                    autoSwipeHorizontal = delta.deltaX > sliderSize.width / _this7.autoSwipeRatio;
                    autoSwipeVertical = delta.deltaY > sliderSize.height / _this7.autoSwipeRatio;
                    if (autoSwipeHorizontal || autoSwipeVertical) {
                      _this7.deckMove = _this7.dir !== 'horizontal' ? delta.swipeNext ? _this7.deckMove - sliderSize.height : _this7.deckMove + sliderSize.height : delta.swipeNext ? _this7.deckMove - sliderSize.width : _this7.deckMove + sliderSize.width;
                      if (_this7.isNextChange(delta.swipeNext)) {
                        _this7.activeIndex++;
                        if (emitEvent) {
                          _this7.slideNextDidChange.emit(_this7.activeIndex);
                        }
                      } else {
                        _this7.activeIndex--;
                        if (emitEvent) {
                          _this7.slidePrevDidChange.emit(_this7.activeIndex);
                        }
                      }
                    }
                  }
                  _context36.next = 9;
                  return _this7.doSwipeSlide();
                case 9:
                  resolve();
                case 10:
                case "end":
                  return _context36.stop();
              }
            }
          }, _callee36);
        }));
        return function (_x26) {
          return _ref15.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "isNextChange",
    value: function isNextChange(swipeLeft) {
      return swipeLeft && !this.rtl || !swipeLeft && this.rtl;
    }
  }, {
    key: "doSwipeSlide",
    value: function doSwipeSlide(speed) {
      var _this8 = this;
      return new Promise(function (resolve) {
        var _a, _b, _c, _d;
        if (_this8.dir === 'horizontal') {
          (_a = _this8.containerRef) === null || _a === void 0 ? void 0 : _a.style.setProperty('--transformX', _this8.deckMove + 'px');
        }
        if (_this8.dir === 'vertical') {
          (_b = _this8.containerRef) === null || _b === void 0 ? void 0 : _b.style.setProperty('--transformY', _this8.deckMove + 'px');
        }
        if (_this8.animation === 'slide') {
          (_c = _this8.containerRef) === null || _c === void 0 ? void 0 : _c.style.setProperty('--transformXDuration', '' + (!isNaN(speed) ? speed : 300) + 'ms');
        } else {
          (_d = _this8.containerRef) === null || _d === void 0 ? void 0 : _d.style.setProperty('--transformXDuration', '0ms');
        }
        if (_this8.dir === 'papyrus') {
          var slide = _this8.el.querySelector('.deckgo-slide-container:nth-child(' + (_this8.activeIndex + 1) + ')');
          // HACK: Chrome does not perform any scroll if the behavior 'smooth' is set and the event is triggered programmatically or with the keyboard aka only works if triggered with a click event
          setTimeout(function () {
            slide === null || slide === void 0 ? void 0 : slide.scrollIntoView(_this8.animation === 'none' ? null : {
              behavior: 'smooth',
              block: 'nearest'
            });
          }, 0);
        }
        _this8.slideWillChange.emit(_this8.deckMove);
        _this8.resetStart();
        resolve();
      });
    }
  }, {
    key: "resetStart",
    value: function resetStart() {
      this.startX = null;
      this.startY = null;
    }
  }, {
    key: "getDelta",
    value: function () {
      var _getDelta = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37($event) {
        var currentX, currentY, swipeLeft, swipeTop;
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                if (!(!this.startX && this.dir === 'horizontal')) {
                  _context37.next = 2;
                  break;
                }
                return _context37.abrupt("return", null);
              case 2:
                if (!(!this.startY && this.dir === 'vertical')) {
                  _context37.next = 4;
                  break;
                }
                return _context37.abrupt("return", null);
              case 4:
                if (!(this.dir === 'papyrus')) {
                  _context37.next = 6;
                  break;
                }
                return _context37.abrupt("return", null);
              case 6:
                currentX = l($event).clientX;
                currentY = l($event).clientY;
                if (!(this.startX === currentX && this.dir === 'horizontal')) {
                  _context37.next = 12;
                  break;
                }
                return _context37.abrupt("return", null);
              case 12:
                if (!(this.startY === currentY && this.dir === 'vertical')) {
                  _context37.next = 14;
                  break;
                }
                return _context37.abrupt("return", null);
              case 14:
                swipeLeft = this.startX > currentX && this.dir === 'horizontal';
                swipeTop = this.startY > currentY && this.dir === 'vertical';
                return _context37.abrupt("return", {
                  swipeNext: swipeLeft || swipeTop,
                  deltaX: swipeLeft ? this.startX - currentX : currentX - this.startX,
                  deltaY: swipeTop ? this.startY - currentY : currentY - this.startY
                });
              case 17:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));
      function getDelta(_x27) {
        return _getDelta.apply(this, arguments);
      }
      return getDelta;
    }()
    /* END: Handle swipe */
    /* BEGIN: Slide length and active index */
  }, {
    key: "slideDidLoad",
    value: function () {
      var _slideDidLoad = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38() {
        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                _context38.next = 2;
                return this.updateLength();
              case 2:
                _context38.next = 4;
                return this.afterSlidesDidLoad();
              case 4:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));
      function slideDidLoad() {
        return _slideDidLoad.apply(this, arguments);
      }
      return slideDidLoad;
    }()
  }, {
    key: "updateLength",
    value: function () {
      var _updateLength = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39() {
        var filteredSlides;
        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                _context39.next = 2;
                return this.getDefinedFilteredSlides();
              case 2:
                filteredSlides = _context39.sent;
                this.length = filteredSlides ? filteredSlides.length : 0;
              case 4:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));
      function updateLength() {
        return _updateLength.apply(this, arguments);
      }
      return updateLength;
    }()
  }, {
    key: "afterSlidesDidLoad",
    value: function afterSlidesDidLoad() {
      var _this9 = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(resolve) {
          var deckDefinition;
          return _regeneratorRuntime.wrap(function _callee40$(_context40) {
            while (1) {
              switch (_context40.prev = _context40.next) {
                case 0:
                  _context40.next = 2;
                  return _this9.getDeckDefinition();
                case 2:
                  deckDefinition = _context40.sent;
                  if (!(deckDefinition && deckDefinition.slides && deckDefinition.slides.length > 0)) {
                    _context40.next = 8;
                    break;
                  }
                  _this9.slidesDidLoad.emit(deckDefinition);
                  _context40.next = 7;
                  return _this9.onAllSlidesDidLoad();
                case 7:
                  _this9.deckDidLoad.emit();
                case 8:
                  resolve();
                case 9:
                case "end":
                  return _context40.stop();
              }
            }
          }, _callee40);
        }));
        return function (_x28) {
          return _ref16.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "onAllSlidesDidLoad",
    value: function onAllSlidesDidLoad() {
      var _this10 = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(resolve) {
          var filteredSlides, promises;
          return _regeneratorRuntime.wrap(function _callee41$(_context41) {
            while (1) {
              switch (_context41.prev = _context41.next) {
                case 0:
                  _context41.next = 2;
                  return _this10.getDefinedFilteredSlides();
                case 2:
                  filteredSlides = _context41.sent;
                  promises = [];
                  promises.push(_this10.initLazyLoadContent());
                  promises.push(DeckdeckgoDeckBackgroundUtils.loadSlots(_this10.el, filteredSlides, 'background', _this10.cloneBackground));
                  if (_this10.dir !== 'papyrus') {
                    promises.push(DeckdeckgoDeckBackgroundUtils.cloneSlots(_this10.el, filteredSlides, 'actions'));
                    promises.push(DeckdeckgoDeckBackgroundUtils.loadSlots(_this10.el, filteredSlides, 'header'));
                    promises.push(DeckdeckgoDeckBackgroundUtils.loadSlots(_this10.el, filteredSlides, 'footer'));
                  } else if (filteredSlides && filteredSlides.length > 0) {
                    promises.push(DeckdeckgoDeckBackgroundUtils.cloneSlot(_this10.el, filteredSlides[0], 'actions'));
                    promises.push(DeckdeckgoDeckBackgroundUtils.loadSlot(_this10.el, filteredSlides[0], 'header'));
                    promises.push(DeckdeckgoDeckBackgroundUtils.loadSlot(_this10.el, filteredSlides[filteredSlides.length - 1], 'footer'));
                  }
                  // In standard case, we want to be able to reveal elements or not, as we wish but if we set reveal to false, we want to display everything straight at the begin.
                  // Or we display also all reveal elements on mobile devices as there is no keyboard on mobile device to reveal elements
                  // Also, no reveal for papyrus as we can scroll
                  if (!_this10.reveal || !_this10.revealOnMobile && _this10.mobile || _this10.dir === 'papyrus') {
                    promises.push(_this10.revealAllContent());
                  }
                  _context41.next = 10;
                  return Promise.all(promises);
                case 10:
                  resolve();
                case 11:
                case "end":
                  return _context41.stop();
              }
            }
          }, _callee41);
        }));
        return function (_x29) {
          return _ref17.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "getDeckDefinition",
    value: function getDeckDefinition() {
      var _this11 = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(resolve) {
          var loadedSlides, filteredSlides, definedSlidesLength, orderedSlidesTagNames, _i, _Array$from, slide, _attributes, attributes, background, deck;
          return _regeneratorRuntime.wrap(function _callee42$(_context42) {
            while (1) {
              switch (_context42.prev = _context42.next) {
                case 0:
                  loadedSlides = _this11.el.querySelectorAll('.deckgo-slide-container.hydrated');
                  if (!(!loadedSlides || loadedSlides.length <= 0)) {
                    _context42.next = 4;
                    break;
                  }
                  resolve(null);
                  return _context42.abrupt("return");
                case 4:
                  _context42.next = 6;
                  return _this11.getDefinedFilteredSlides();
                case 6:
                  filteredSlides = _context42.sent;
                  definedSlidesLength = filteredSlides ? filteredSlides.length : 0; // Are all slides loaded?
                  if (!(loadedSlides.length !== definedSlidesLength)) {
                    _context42.next = 11;
                    break;
                  }
                  resolve(null);
                  return _context42.abrupt("return");
                case 11:
                  orderedSlidesTagNames = [];
                  _i = 0, _Array$from = Array.from(loadedSlides);
                case 13:
                  if (!(_i < _Array$from.length)) {
                    _context42.next = 22;
                    break;
                  }
                  slide = _Array$from[_i];
                  _context42.next = 17;
                  return c(slide.attributes);
                case 17:
                  _attributes = _context42.sent;
                  orderedSlidesTagNames.push({
                    template: slide.tagName ? slide.tagName.toLowerCase() : undefined,
                    content: slide.innerHTML,
                    attributes: _attributes
                  });
                case 19:
                  _i++;
                  _context42.next = 13;
                  break;
                case 22:
                  _context42.next = 24;
                  return c(_this11.el.attributes);
                case 24:
                  attributes = _context42.sent;
                  background = _this11.el.querySelector(":scope > [slot='background']");
                  deck = {
                    slides: orderedSlidesTagNames,
                    attributes: attributes,
                    background: background ? background.innerHTML : null,
                    reveal: _this11.reveal,
                    revealOnMobile: _this11.revealOnMobile
                  };
                  resolve(deck);
                case 28:
                case "end":
                  return _context42.stop();
              }
            }
          }, _callee42);
        }));
        return function (_x30) {
          return _ref18.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "getSlideDefinition",
    value: function getSlideDefinition(index) {
      var _this12 = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(resolve) {
          var slide, definition;
          return _regeneratorRuntime.wrap(function _callee43$(_context43) {
            while (1) {
              switch (_context43.prev = _context43.next) {
                case 0:
                  slide = _this12.el.querySelector('.deckgo-slide-container:nth-child(' + (index + 1) + ')');
                  _context43.next = 3;
                  return a(slide);
                case 3:
                  definition = _context43.sent;
                  resolve(definition);
                case 5:
                case "end":
                  return _context43.stop();
              }
            }
          }, _callee43);
        }));
        return function (_x31) {
          return _ref19.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "getDefinedFilteredSlides",
    value: function getDefinedFilteredSlides() {
      var _this13 = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(resolve) {
          var definedSlides, filteredSlides;
          return _regeneratorRuntime.wrap(function _callee44$(_context44) {
            while (1) {
              switch (_context44.prev = _context44.next) {
                case 0:
                  definedSlides = _this13.el.children;
                  _context44.next = 3;
                  return _this13.filterSlides(definedSlides);
                case 3:
                  filteredSlides = _context44.sent;
                  resolve(filteredSlides);
                case 5:
                case "end":
                  return _context44.stop();
              }
            }
          }, _callee44);
        }));
        return function (_x32) {
          return _ref20.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "loadBackground",
    value: function loadBackground() {
      return this.loadSlots('background', this.cloneBackground);
    }
  }, {
    key: "loadHeader",
    value: function loadHeader() {
      return this.loadSlots('header');
    }
  }, {
    key: "loadFooter",
    value: function loadFooter() {
      return this.loadSlots('footer');
    }
  }, {
    key: "loadSlots",
    value: function () {
      var _loadSlots = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(slotName) {
        var clone,
          filteredSlides,
          _args45 = arguments;
        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                clone = _args45.length > 1 && _args45[1] !== undefined ? _args45[1] : true;
                _context45.next = 3;
                return this.getDefinedFilteredSlides();
              case 3:
                filteredSlides = _context45.sent;
                if (!(!filteredSlides || filteredSlides.length <= 0)) {
                  _context45.next = 6;
                  break;
                }
                return _context45.abrupt("return");
              case 6:
                _context45.next = 8;
                return DeckdeckgoDeckBackgroundUtils.removeSlots(filteredSlides, slotName);
              case 8:
                _context45.next = 10;
                return DeckdeckgoDeckBackgroundUtils.loadSlots(this.el, filteredSlides, slotName, clone);
              case 10:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45, this);
      }));
      function loadSlots(_x33) {
        return _loadSlots.apply(this, arguments);
      }
      return loadSlots;
    }() // The last children might be slots (background, note or action)
  }, {
    key: "filterSlides",
    value: function filterSlides(definedSlides) {
      return new Promise(function (resolve) {
        if (!definedSlides || definedSlides.length <= 0) {
          resolve(null);
          return;
        }
        var slides = Array.from(definedSlides).filter(function (slide) {
          return !slide.hasAttribute('slot') || slide.getAttribute('slot') === '';
        });
        resolve(slides);
      });
    }
  }, {
    key: "isBeginning",
    value: function isBeginning() {
      var _this14 = this;
      return new Promise(function (resolve) {
        resolve(_this14.activeIndex === 0);
      });
    }
  }, {
    key: "isEnd",
    value: function isEnd() {
      var _this15 = this;
      return new Promise(function (resolve) {
        resolve(_this15.activeIndex === _this15.length - 1);
      });
    }
  }, {
    key: "getActiveIndex",
    value: function getActiveIndex() {
      var _this16 = this;
      return new Promise(function (resolve) {
        resolve(_this16.activeIndex);
      });
    }
  }, {
    key: "getLength",
    value: function getLength() {
      var _this17 = this;
      return new Promise(function (resolve) {
        resolve(_this17.length);
      });
    }
    /* END: Slide length and active index */
    /* BEGIN: Manual sliding */
  }, {
    key: "slideNext",
    value: function () {
      var _slideNext = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(slideAnimation, emitEvent) {
        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                _context46.next = 2;
                return this.slideNextPrev(!this.rtl, slideAnimation, emitEvent);
              case 2:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46, this);
      }));
      function slideNext(_x34, _x35) {
        return _slideNext.apply(this, arguments);
      }
      return slideNext;
    }()
  }, {
    key: "slidePrev",
    value: function () {
      var _slidePrev = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47(slideAnimation, emitEvent) {
        return _regeneratorRuntime.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                _context47.next = 2;
                return this.slideNextPrev(this.rtl, slideAnimation, emitEvent);
              case 2:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47, this);
      }));
      function slidePrev(_x36, _x37) {
        return _slidePrev.apply(this, arguments);
      }
      return slidePrev;
    }()
  }, {
    key: "slideNextPrev",
    value: function () {
      var _slideNextPrev = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(swipeNext) {
        var slideAnimation,
          emitEvent,
          slider,
          couldSwipe,
          sliderSize,
          deltaX,
          _args48 = arguments;
        return _regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                slideAnimation = _args48.length > 1 && _args48[1] !== undefined ? _args48[1] : true;
                emitEvent = _args48.length > 2 ? _args48[2] : undefined;
                slider = this.el.shadowRoot.querySelector('div.deckgo-deck');
                if (!(!slider || !window)) {
                  _context48.next = 5;
                  break;
                }
                return _context48.abrupt("return");
              case 5:
                if (slideAnimation) {
                  _context48.next = 9;
                  break;
                }
                couldSwipe = true;
                _context48.next = 12;
                break;
              case 9:
                _context48.next = 11;
                return this.beforeSwipe(this.isNextChange(swipeNext));
              case 11:
                couldSwipe = _context48.sent;
              case 12:
                if (!couldSwipe) {
                  _context48.next = 21;
                  break;
                }
                sliderSize = this.containerSize();
                deltaX = {
                  swipeNext: swipeNext,
                  deltaX: sliderSize.width,
                  deltaY: sliderSize.height
                };
                _context48.next = 17;
                return this.swipeSlide(deltaX, emitEvent);
              case 17:
                _context48.next = 19;
                return this.afterSwipe(swipeNext);
              case 19:
                _context48.next = 22;
                break;
              case 21:
                if (emitEvent) {
                  if (swipeNext) {
                    this.slideNextDidAnimate.emit();
                  } else {
                    this.slidePrevDidAnimate.emit();
                  }
                }
              case 22:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, this);
      }));
      function slideNextPrev(_x38) {
        return _slideNextPrev.apply(this, arguments);
      }
      return slideNextPrev;
    }()
  }, {
    key: "beforeSwipe",
    value: function beforeSwipe(enter) {
      var _this18 = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(resolve) {
          var slide, result;
          return _regeneratorRuntime.wrap(function _callee49$(_context49) {
            while (1) {
              switch (_context49.prev = _context49.next) {
                case 0:
                  slide = _this18.el.querySelector('.deckgo-slide-container:nth-child(' + (_this18.activeIndex + 1) + ')');
                  if (slide) {
                    _context49.next = 5;
                    break;
                  }
                  // If we find no slide, we are cool something went wrong but the talk/show must go on
                  resolve(true);
                  _context49.next = 9;
                  break;
                case 5:
                  _context49.next = 7;
                  return slide.beforeSwipe(enter, _this18.reveal);
                case 7:
                  result = _context49.sent;
                  resolve(result);
                case 9:
                case "end":
                  return _context49.stop();
              }
            }
          }, _callee49);
        }));
        return function (_x39) {
          return _ref21.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "afterSwipe",
    value: function afterSwipe(swipeLeft) {
      var _this19 = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(resolve) {
          var indexPreviousSlide, slide;
          return _regeneratorRuntime.wrap(function _callee50$(_context50) {
            while (1) {
              switch (_context50.prev = _context50.next) {
                case 0:
                  indexPreviousSlide = swipeLeft ? _this19.activeIndex - 1 : _this19.activeIndex + 1;
                  if (!(isNaN(indexPreviousSlide) || indexPreviousSlide < 0 || indexPreviousSlide > _this19.length)) {
                    _context50.next = 4;
                    break;
                  }
                  resolve();
                  return _context50.abrupt("return");
                case 4:
                  slide = _this19.el.querySelector('.deckgo-slide-container:nth-child(' + (indexPreviousSlide + 1) + ')');
                  if (slide) {
                    _context50.next = 9;
                    break;
                  }
                  // Might be a swipe after the first or last slide
                  resolve();
                  _context50.next = 12;
                  break;
                case 9:
                  _context50.next = 11;
                  return slide.afterSwipe();
                case 11:
                  resolve();
                case 12:
                case "end":
                  return _context50.stop();
              }
            }
          }, _callee50);
        }));
        return function (_x40) {
          return _ref22.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "lazyLoadContent",
    value: function () {
      var _lazyLoadContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51(index) {
        var slide;
        return _regeneratorRuntime.wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                slide = this.el.querySelector('.deckgo-slide-container:nth-child(' + (index + 1) + ')');
                if (!slide) {
                  _context51.next = 4;
                  break;
                }
                _context51.next = 4;
                return slide.lazyLoadContent();
              case 4:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51, this);
      }));
      function lazyLoadContent(_x41) {
        return _lazyLoadContent.apply(this, arguments);
      }
      return lazyLoadContent;
    }()
  }, {
    key: "slideTo",
    value: function () {
      var _slideTo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52(index, speed) {
        var emitEvent,
          slider,
          sliderSize,
          _args52 = arguments;
        return _regeneratorRuntime.wrap(function _callee52$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                emitEvent = _args52.length > 2 && _args52[2] !== undefined ? _args52[2] : true;
                if (!(index > this.length || index < 0)) {
                  _context52.next = 3;
                  break;
                }
                return _context52.abrupt("return");
              case 3:
                slider = this.el.shadowRoot.querySelector('div.deckgo-deck');
                if (!(!slider || !window)) {
                  _context52.next = 6;
                  break;
                }
                return _context52.abrupt("return");
              case 6:
                sliderSize = this.containerSize();
                this.deckMove = index * (this.dir === 'horizontal' ? sliderSize.width : sliderSize.height) * (this.rtl ? 1 : -1);
                this.activeIndex = index;
                _context52.next = 11;
                return this.doSwipeSlide(speed);
              case 11:
                // In case we are sliding to a slide which received focus before being displayed (previously outside viewport)
                // a scroll on the parent element would have been applied by the browser. Therefore we set it back to the origin, as we takes care of the positioning of the slider.
                slider.parentElement.scrollTo(0, 0);
                if (emitEvent) {
                  this.slideToChange.emit(index);
                }
              case 13:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee52, this);
      }));
      function slideTo(_x42, _x43) {
        return _slideTo.apply(this, arguments);
      }
      return slideTo;
    }()
  }, {
    key: "deleteActiveSlide",
    value: function () {
      var _deleteActiveSlide = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53() {
        var removeChild,
          slide,
          _args53 = arguments;
        return _regeneratorRuntime.wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                removeChild = _args53.length > 0 && _args53[0] !== undefined ? _args53[0] : true;
                if (!(this.activeIndex > this.length || this.activeIndex < 0)) {
                  _context53.next = 3;
                  break;
                }
                return _context53.abrupt("return");
              case 3:
                if (removeChild) {
                  slide = this.el.querySelector('.deckgo-slide-container:nth-child(' + (this.activeIndex + 1) + ')');
                  slide === null || slide === void 0 ? void 0 : slide.parentElement.removeChild(slide);
                }
                this.activeIndex = this.activeIndex > 0 ? this.activeIndex - 1 : 0;
                this.length = this.length > 0 ? this.length - 1 : 0;
                if (!(this.length > 0)) {
                  _context53.next = 9;
                  break;
                }
                _context53.next = 9;
                return this.slideTo(this.activeIndex, 0);
              case 9:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53, this);
      }));
      function deleteActiveSlide() {
        return _deleteActiveSlide.apply(this, arguments);
      }
      return deleteActiveSlide;
    }()
  }, {
    key: "blockSlide",
    value: function () {
      var _blockSlide = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54(block) {
        return _regeneratorRuntime.wrap(function _callee54$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                this.block = block;
                // If we want to block, then we reset then previous start position as we don't want to start the slide to scroll when the blocking will be resolved
                if (this.block) {
                  this.resetStart();
                }
              case 2:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee54, this);
      }));
      function blockSlide(_x44) {
        return _blockSlide.apply(this, arguments);
      }
      return blockSlide;
    }()
    /* END: Manual sliding */
    /* BEGIN: Full screen */
  }, {
    key: "toggleFullScreen",
    value: function toggleFullScreen() {
      return new Promise( /*#__PURE__*/function () {
        var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55(resolve) {
          var doc, docEl, requestFullScreen, cancelFullScreen;
          return _regeneratorRuntime.wrap(function _callee55$(_context55) {
            while (1) {
              switch (_context55.prev = _context55.next) {
                case 0:
                  doc = window.document;
                  docEl = doc.documentElement; // @ts-ignore
                  // prettier-ignore
                  requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen; // @ts-ignore
                  cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen; // @ts-ignore
                  if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
                    requestFullScreen.call(docEl);
                  } else {
                    cancelFullScreen.call(doc);
                  }
                  resolve();
                case 6:
                case "end":
                  return _context55.stop();
              }
            }
          }, _callee55);
        }));
        return function (_x45) {
          return _ref23.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "hideOrClearMouseCursorTimer",
    value: function () {
      var _hideOrClearMouseCursorTimer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57(toggleFullscreen) {
        var _this20 = this;
        return _regeneratorRuntime.wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                if (!toggleFullscreen) {
                  _context57.next = 6;
                  break;
                }
                this.fullscreen = true;
                // We are entering fullscreen mode now, therefore we don't want to want two seconds to hide the mouse
                setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56() {
                  return _regeneratorRuntime.wrap(function _callee56$(_context56) {
                    while (1) {
                      switch (_context56.prev = _context56.next) {
                        case 0:
                          _context56.next = 2;
                          return _this20.showHideMouseCursor(false);
                        case 2:
                        case "end":
                          return _context56.stop();
                      }
                    }
                  }, _callee56);
                })), 500);
                this.hideMouseCursorWithDelay();
                _context57.next = 9;
                break;
              case 6:
                _context57.next = 8;
                return this.clearMouseCursorTimer(false);
              case 8:
                this.fullscreen = false;
              case 9:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57, this);
      }));
      function hideOrClearMouseCursorTimer(_x46) {
        return _hideOrClearMouseCursorTimer.apply(this, arguments);
      }
      return hideOrClearMouseCursorTimer;
    }()
  }, {
    key: "clearMouseCursorTimer",
    value: function () {
      var _clearMouseCursorTimer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58(hideWithDelay) {
        return _regeneratorRuntime.wrap(function _callee58$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                if (this.fullscreen) {
                  _context58.next = 2;
                  break;
                }
                return _context58.abrupt("return");
              case 2:
                if (this.idleMouseTimer > 0) {
                  clearTimeout(this.idleMouseTimer);
                }
                _context58.next = 5;
                return this.showHideMouseCursor(true);
              case 5:
                if (hideWithDelay) {
                  this.hideMouseCursorWithDelay();
                }
              case 6:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee58, this);
      }));
      function clearMouseCursorTimer(_x47) {
        return _clearMouseCursorTimer.apply(this, arguments);
      }
      return clearMouseCursorTimer;
    }()
  }, {
    key: "hideMouseCursorWithDelay",
    value: function hideMouseCursorWithDelay() {
      var _this21 = this;
      if (!this.fullscreen) {
        return;
      }
      this.idleMouseTimer = window.setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59() {
        return _regeneratorRuntime.wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                _context59.next = 2;
                return _this21.showHideMouseCursor(false);
              case 2:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59);
      })), this.idleMouseTimeout);
    }
  }, {
    key: "showHideMouseCursor",
    value: function showHideMouseCursor(show) {
      var _this22 = this;
      return new Promise(function (resolve) {
        var _a;
        if (!_this22.fullscreen) {
          resolve();
          return;
        }
        if (!_this22.cursorHidden && show) {
          // Cursor already displayed, we don't want to touch the style multiple times if not needed
          resolve();
          return;
        }
        (_a = _this22.containerRef) === null || _a === void 0 ? void 0 : _a.style.setProperty('cursor', show ? 'inherit' : 'none');
        _this22.mouseInactivity.emit(show);
        _this22.cursorHidden = !show;
        resolve();
      });
    }
  }, {
    key: "showHideActionsSlot",
    value: function () {
      var _showHideActionsSlot = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60(toggleFullscreen) {
        var _a, _b;
        return _regeneratorRuntime.wrap(function _callee60$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                if (toggleFullscreen) {
                  (_a = this.containerRef) === null || _a === void 0 ? void 0 : _a.style.setProperty('--slide-actions-display', 'none');
                } else {
                  (_b = this.containerRef) === null || _b === void 0 ? void 0 : _b.style.removeProperty('--slide-actions-display');
                }
              case 1:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee60, this);
      }));
      function showHideActionsSlot(_x48) {
        return _showHideActionsSlot.apply(this, arguments);
      }
      return showHideActionsSlot;
    }()
    /* END: Full screen */
    /* BEGIN: Utils */
  }, {
    key: "doPrint",
    value: function () {
      var _doPrint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee62() {
        var _this23 = this;
        var dir, onRender, docObserver;
        return _regeneratorRuntime.wrap(function _callee62$(_context62) {
          while (1) {
            switch (_context62.prev = _context62.next) {
              case 0:
                dir = this.direction;
                window.addEventListener('afterprint', function () {
                  return _this23.direction = dir;
                }, {
                  once: true
                });
                onRender = /*#__PURE__*/function () {
                  var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee61(_mutations, observer) {
                    return _regeneratorRuntime.wrap(function _callee61$(_context61) {
                      while (1) {
                        switch (_context61.prev = _context61.next) {
                          case 0:
                            observer.disconnect();
                            _context61.next = 3;
                            return Promise.all([_this23.lazyLoadAllContent(), _this23.revealAllContent()]);
                          case 3:
                            window.print();
                          case 4:
                          case "end":
                            return _context61.stop();
                        }
                      }
                    }, _callee61);
                  }));
                  return function onRender(_x49, _x50) {
                    return _ref26.apply(this, arguments);
                  };
                }();
                docObserver = new MutationObserver(onRender);
                docObserver.observe(this.el, {
                  attributes: true
                });
                this.direction = 'vertical';
              case 6:
              case "end":
                return _context62.stop();
            }
          }
        }, _callee62, this);
      }));
      function doPrint() {
        return _doPrint.apply(this, arguments);
      }
      return doPrint;
    }()
  }, {
    key: "lazyLoadAllContent",
    value: function lazyLoadAllContent() {
      var promises = [];
      for (var i = 0; i < this.length; i++) {
        promises.push(this.lazyLoadContent(i));
      }
      return Promise.all(promises);
    }
    /* END: Utils */
    /* BEGIN: Reveal */
  }, {
    key: "onRevealChange",
    value: function () {
      var _onRevealChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee63() {
        return _regeneratorRuntime.wrap(function _callee63$(_context63) {
          while (1) {
            switch (_context63.prev = _context63.next) {
              case 0:
                if (this.reveal) {
                  _context63.next = 5;
                  break;
                }
                _context63.next = 3;
                return this.revealAllContent();
              case 3:
                _context63.next = 7;
                break;
              case 5:
                _context63.next = 7;
                return this.redoRevealContent();
              case 7:
              case "end":
                return _context63.stop();
            }
          }
        }, _callee63, this);
      }));
      function onRevealChange() {
        return _onRevealChange.apply(this, arguments);
      }
      return onRevealChange;
    }()
  }, {
    key: "revealAllContent",
    value: function revealAllContent() {
      var _this24 = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee64(resolve) {
          var promises, i;
          return _regeneratorRuntime.wrap(function _callee64$(_context64) {
            while (1) {
              switch (_context64.prev = _context64.next) {
                case 0:
                  promises = [];
                  for (i = 0; i < _this24.length; i++) {
                    promises.push(_this24.revealContent(i));
                  }
                  _context64.next = 4;
                  return Promise.all(promises);
                case 4:
                  resolve();
                case 5:
                case "end":
                  return _context64.stop();
              }
            }
          }, _callee64);
        }));
        return function (_x51) {
          return _ref27.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "redoRevealContent",
    value: function redoRevealContent() {
      var _this25 = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee65(resolve) {
          var promises, i;
          return _regeneratorRuntime.wrap(function _callee65$(_context65) {
            while (1) {
              switch (_context65.prev = _context65.next) {
                case 0:
                  // If we switch back to standard mode, reveal previous slide and hide the "reveal" content of this and next slides
                  promises = [];
                  for (i = 0; i < _this25.length; i++) {
                    if (i < _this25.activeIndex) {
                      promises.push(_this25.revealContent(i));
                    } else {
                      promises.push(_this25.hideContent(i));
                    }
                  }
                  _context65.next = 4;
                  return Promise.all(promises);
                case 4:
                  resolve();
                case 5:
                case "end":
                  return _context65.stop();
              }
            }
          }, _callee65);
        }));
        return function (_x52) {
          return _ref28.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "revealContent",
    value: function () {
      var _revealContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee66(index) {
        var slide;
        return _regeneratorRuntime.wrap(function _callee66$(_context66) {
          while (1) {
            switch (_context66.prev = _context66.next) {
              case 0:
                slide = this.el.querySelector('.deckgo-slide-container:nth-child(' + (index + 1) + ')');
                if (!slide) {
                  _context66.next = 4;
                  break;
                }
                _context66.next = 4;
                return slide.revealContent();
              case 4:
              case "end":
                return _context66.stop();
            }
          }
        }, _callee66, this);
      }));
      function revealContent(_x53) {
        return _revealContent.apply(this, arguments);
      }
      return revealContent;
    }()
  }, {
    key: "hideContent",
    value: function () {
      var _hideContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee67(index) {
        var slide;
        return _regeneratorRuntime.wrap(function _callee67$(_context67) {
          while (1) {
            switch (_context67.prev = _context67.next) {
              case 0:
                slide = this.el.querySelector('.deckgo-slide-container:nth-child(' + (index + 1) + ')');
                if (!slide) {
                  _context67.next = 4;
                  break;
                }
                _context67.next = 4;
                return slide.hideContent();
              case 4:
              case "end":
                return _context67.stop();
            }
          }
        }, _callee67, this);
      }));
      function hideContent(_x54) {
        return _hideContent.apply(this, arguments);
      }
      return hideContent;
    }()
    /* END: Reveal */
    /* BEGIN: AutoSlide */
  }, {
    key: "initAutoSlide",
    value: function () {
      var _initAutoSlide = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee68() {
        return _regeneratorRuntime.wrap(function _callee68$(_context68) {
          while (1) {
            switch (_context68.prev = _context68.next) {
              case 0:
                if (!(this.autoSlide === 'true')) {
                  _context68.next = 3;
                  break;
                }
                _context68.next = 3;
                return this.onAutoSlide();
              case 3:
              case "end":
                return _context68.stop();
            }
          }
        }, _callee68, this);
      }));
      function initAutoSlide() {
        return _initAutoSlide.apply(this, arguments);
      }
      return initAutoSlide;
    }()
  }, {
    key: "onAutoSlide",
    value: function () {
      var _onAutoSlide = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee70() {
        var _this26 = this;
        var idleMouseTimer;
        return _regeneratorRuntime.wrap(function _callee70$(_context70) {
          while (1) {
            switch (_context70.prev = _context70.next) {
              case 0:
                this.idleSlideLoopTimer = window.setTimeout(function () {
                  return idleMouseTimer = _this26.idleMouseTimer;
                }, this.idleMouseTimeout);
                if (this.autoSlide === 'true') {
                  this.slideLoopInterval = window.setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee69() {
                    var end;
                    return _regeneratorRuntime.wrap(function _callee69$(_context69) {
                      while (1) {
                        switch (_context69.prev = _context69.next) {
                          case 0:
                            if (!(idleMouseTimer === _this26.idleMouseTimer)) {
                              _context69.next = 13;
                              break;
                            }
                            _context69.next = 3;
                            return _this26.isEnd();
                          case 3:
                            end = _context69.sent;
                            if (!end) {
                              _context69.next = 9;
                              break;
                            }
                            _context69.next = 7;
                            return _this26.slideTo(0, 0);
                          case 7:
                            _context69.next = 11;
                            break;
                          case 9:
                            _context69.next = 11;
                            return _this26.slideNext(true);
                          case 11:
                            _context69.next = 14;
                            break;
                          case 13:
                            idleMouseTimer = _this26.idleMouseTimer;
                          case 14:
                          case "end":
                            return _context69.stop();
                        }
                      }
                    }, _callee69);
                  })), this.autoSlideInterval);
                } else {
                  clearInterval(this.slideLoopInterval);
                }
              case 2:
              case "end":
                return _context70.stop();
            }
          }
        }, _callee70, this);
      }));
      function onAutoSlide() {
        return _onAutoSlide.apply(this, arguments);
      }
      return onAutoSlide;
    }() /* END: AutoSlide */
  }, {
    key: "render",
    value: function render() {
      var _this27 = this;
      return h(Host, {
        class: "".concat(this.dir)
      }, h("main", null, this.renderAnimation(), h("div", {
        class: "deckgo-deck",
        ref: function ref(el) {
          return _this27.containerRef = el;
        }
      }, h("slot", null), h("slot", {
        name: "actions"
      }), h("slot", {
        name: "background"
      })), h("slot", {
        name: "pager"
      })));
    }
  }, {
    key: "renderAnimation",
    value: function renderAnimation() {
      if (this.animation !== 'fade' || this.dir === 'papyrus') {
        return h(AnimationSlide, null);
      }
      return [h(HideSlides, null), h(RevealSlide, {
        index: this.activeIndex
      })];
    }
  }, {
    key: "el",
    get: function get() {
      return getElement(this);
    }
  }], [{
    key: "watchers",
    get: function get() {
      return {
        "directionMobile": ["onDirectionMobileChange"],
        "direction": ["onDirectionChange"],
        "reveal": ["onRevealChange"],
        "autoSlide": ["onAutoSlide"]
      };
    }
  }]);
  return DeckGoDeck;
}();
DeckGoDeck.style = deckCss;
export { DeckGoDeck as deckgo_deck };